<template>
  <Card>
    <div class="banner">
      <div class="icon">!</div>
      <h2 class="title">{{ title }}</h2>
      <p class="desc">{{ message }}</p>
    </div>
    <template #footer>
      <button class="btn btn-primary full" @click="$emit('retry')">重試</button>
    </template>
  </Card>
</template>

<script setup lang="ts">
import Card from './Card.vue'

defineProps<{
  title?: string
  message: string
}>()

defineEmits<{ (e: 'retry'): void }>()
</script>

<style scoped>
.banner {
  text-align: center;
  padding: 12px 0;
}
.icon {
  width: 56px;
  height: 56px;
  margin: 0 auto 12px;
  background: #dc2626;
  color: #fff;
  border-radius: 50%;
  font-size: 30px;
  line-height: 56px;
  font-weight: 700;
}
.title {
  margin: 0;
  font-size: 20px;
  color: #111827;
}
.desc {
  margin: 8px 0 0;
  color: #6b7280;
  font-size: 14px;
  line-height: 1.5;
  white-space: pre-line;
}
.full {
  width: 100%;
}
</style>
